import React from 'react';
import { SalesPage } from './components/SalesPage';
interface AppProps {
  showTestimonials?: boolean;
  showPurchaseNotifications?: boolean;
}
export function App({
  showTestimonials = true,
  showPurchaseNotifications = false
}: AppProps) {
  return <SalesPage showTestimonials={showTestimonials} showPurchaseNotifications={showPurchaseNotifications} data-id="element-0" data-mp="3k7i659zv8a4t" />;
}